import { getType, Reducer } from 'typesafe-actions'

import { withLoadingReducer } from '../loading'

import { OrderActions } from './actions'
import { OrderState } from './types'

export const initialState: OrderState = {
  orderItems: [],
  orderMetadata: {
    id: undefined,
    itemCount: 0
  }
}

export const reducer: Reducer<OrderState, OrderActions> = (state = initialState, action) => {
  switch (action.type) {
    case getType(OrderActions.setOrderMetadata): {
      return {
        ...state,
        orderMetadata: action.payload.metadata
      }
    }
    case getType(OrderActions.setOrderItems): {
      return {
        ...state,
        orderItems: action.payload.items
      }
    }
    case getType(OrderActions.setOrderData):
      return {
        ...state,
        orderData: action.payload.order
      }
    case getType(OrderActions.setOrderError):
      return {
        ...state,
        orderError: action.payload.error
      }
    case getType(OrderActions.reset):
      return {
        ...initialState
      }
    default:
      return state
  }
}

export const orderReducer = withLoadingReducer(reducer, 'order', initialState)
